import { Footer, FormWrapper, FromTitle, Logo, Wrapper } from './styled';

import React, { useContext } from 'react';
import { Button, Divider, Flex, Form, Input, notification } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import { UserContext } from 'services/contexts';
import { getRedirectPathAfterLogin } from 'services/authRedirect';
import { auth, googleProvider } from 'services/firebase';
import { signInWithPopup } from 'firebase/auth';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { FcGoogle } from 'react-icons/fc';
import { FirebaseUser } from '../../models/auth';
import { useSessionLoginMutation } from '../../redux/slices/auth';

const Login: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [api, contextHolder] = notification.useNotification();
  const { setUser } = useContext(UserContext);
  const [sessionLogin] = useSessionLoginMutation();

  const handleAuth = async (idToken: string, user: any) => {
    try {
      await sessionLogin({ accessToken: idToken }).unwrap();
      localStorage.setItem('isAuthenticated', JSON.stringify(true));
      setUser(user as unknown as FirebaseUser);
      localStorage.setItem('user', JSON.stringify(user));
      const redirectPath = getRedirectPathAfterLogin(location.search);
      navigate(redirectPath && redirectPath !== '/' ? redirectPath : '/');
    } catch (e) {
      api['error']({
        message: 'ICardio Authentication Error',
        description: 'Please contact ICardio administrator team',
      });
    }
  };

  const onFinish = async (values: any) => {
    try {
      const userCredential = await signInWithEmailAndPassword(
        auth,
        values.username,
        values.password
      );
      const user = userCredential.user;
      const idToken = await user.getIdToken();
      await handleAuth(idToken, user);
    } catch (e) {
      api['error']({
        message: 'ICardio Authentication Error',
        description: 'Please contact ICardio administrator team',
      });
    }
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo);
  };

  const onGoogleAuth = async () => {
    try {
      const firebaseAuthData = await signInWithPopup(auth, googleProvider);
      const user = firebaseAuthData.user;
      const idToken = await user.getIdToken();
      await handleAuth(idToken, user);
    } catch (e) {
      api['error']({
        message: 'ICardio Authentication Error',
        description: 'Please contact ICardio administrator team',
      });
    }
  };

  type FieldType = {
    username?: string;
    password?: string;
    remember?: string;
  };

  return (
    <Wrapper>
      {contextHolder}
      <FormWrapper variant={'borderless'}>
        <Logo
          src="https://staging.labeler.icardio.ai/static/media/logo.bca2567da2abc5deb5bddebc704bfe00.svg"
          alt="logo"
        />
        <FromTitle>Reviewer</FromTitle>
        <Form
          name="basic"
          initialValues={{ remember: true }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Form.Item<FieldType>
            name="username"
            rules={[{ required: true, message: 'Please input your username!' }]}
          >
            <Input placeholder="Username" />
          </Form.Item>

          <Form.Item<FieldType>
            name="password"
            rules={[{ required: true, message: 'Please input your password!' }]}
          >
            <Input.Password placeholder="Password" />
          </Form.Item>

          <Form.Item style={{ marginTop: 50 }}>
            <Button type="primary" htmlType="submit">
              Login
            </Button>
          </Form.Item>

          <Divider style={{ backgroundColor: '#ddd' }} />

          <Flex>
            <Button icon={<FcGoogle />} onClick={onGoogleAuth}>
              Sign in with Google
            </Button>
          </Flex>
        </Form>
      </FormWrapper>
      <Footer>Powered by ICardio.ai © {new Date().getFullYear()}</Footer>
    </Wrapper>
  );
};

export default Login;
